import get from 'lodash/get';

// Actions
// -------
const UPDATE_BOUNDING_RECT = 'REGISTRY/UPDATE_BOUNDING_RECT';

// Action Creators
// ---------------
export const updateBoundingRect = ({ id, boundingRect }) => {
  return {
    type: UPDATE_BOUNDING_RECT,
    payload: { id, boundingRect }
  };
};

// Reducer
// -------
export const registryReducerKey = 'registry';
export const registryReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_BOUNDING_RECT: {
      const { id, boundingRect } = action.payload;
      return {
        ...state,
        [id]: boundingRect
      };
    }

    default:
      return state;
  }
};

// Selectors
// ---------
const getComponentMetadata = (id, state) => {
  return state[registryReducerKey][id];
};

export const getHeight = ({ id, state }) => {
  const meta = getComponentMetadata(id, state);
  return get(meta, 'height', 0);
};

export const getWidth = ({ id, state }) => {
  const meta = getComponentMetadata(id, state);
  return get(meta, 'width', 0);
};

export const getTop = ({ id, state }) => {
  const meta = getComponentMetadata(id, state);
  return get(meta, 'top', 0);
};

export const getBottom = ({ id, state }) => {
  const meta = getComponentMetadata(id, state);
  return get(meta, 'bottom', 0);
};
